import { formatChipsShort } from '@polf/shared/locale'

import Rank from './Rank'

/**
 * "Din plassering" card. Used by every variant's view — the per-variant
 * component computes `yourRank` / `yourPrimary` / etc and passes them in.
 * `unit` flips the trailing copy between "spillere" (individual) and
 * "lag" (team rankings).
 */
const Hero = ({
  yourRank,
  yourPrimary,
  primarySuffix,
  leaderGap,
  totalPlayers,
  unit = 'spillere',
}: {
  yourRank: number | null
  yourPrimary: string
  primarySuffix: string
  leaderGap: number | null
  totalPlayers: number
  unit?: 'spillere' | 'lag'
}) => (
  <div
    className="mx-2 my-3 rounded-xl p-4 text-paper flex items-center gap-4 shadow"
    style={{
      background:
        'linear-gradient(160deg, var(--green-800) 0%, var(--green-900) 100%)',
    }}
  >
    <Rank rank={yourRank} size="lg" />
    <div className="flex-1 min-w-0">
      <div className="text-[10px] up text-green-100">Din plassering</div>
      <div className="font-display font-bold text-base mt-1">
        <span className="font-mono num">{yourPrimary}</span>
        <span className="text-green-100 font-sans font-normal ml-1.5">
          {primarySuffix}
        </span>
      </div>
      <div className="text-[11px] text-green-100 mt-1">
        {yourRank == null
          ? `Du er ikke på listen ennå · ${totalPlayers} ${unit}`
          : yourRank === 1
          ? `Du leder turneringen 🔥`
          : leaderGap != null
          ? `${formatChipsShort(leaderGap)} ${primarySuffix} bak leder`
          : `${totalPlayers} ${unit} totalt`}
      </div>
    </div>
  </div>
)

export default Hero
